import { hasCrmPermissions } from "app/components/SideBar/utils";
import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";

export function getAccessToCRMs(): Record<CrmIntegrationProvider, boolean> {
    const hasCrmAccess = hasCrmPermissions();

    return {
        salesforce: hasCrmAccess,
        hubspot: hasCrmAccess,
        dynamics: hasCrmAccess
    }
}